import { fetchWithAuth } from "../FetchWithAuth";
import { url } from "../url";

const BASE = `${url}/api/whatsapp-chat`;
const WHATSAPP_BASE = `${url}/api/whatsapp`;

async function parseJson(response) {
  return response.json().catch(() => ({}));
}

/** Whether a WhatsApp Business / Cloud API account is registered for this business. */
export async function getWhatsAppStatus(businessId) {
  const query = new URLSearchParams({ business_id: String(businessId) });
  const response = await fetchWithAuth(`${WHATSAPP_BASE}/status?${query.toString()}`, {
    method: "GET",
  });
  return parseJson(response);
}

/** Register or update WhatsApp Cloud API credentials (admin / Manager only). */
export async function registerWhatsAppAccount(payload) {
  const response = await fetchWithAuth(`${WHATSAPP_BASE}/accounts`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function getWhatsAppOAuthUrl() {
  const response = await fetchWithAuth(`${WHATSAPP_BASE}/oauth-url`, { method: "GET" });
  return parseJson(response);
}

export async function listWhatsAppAccounts({ all = false } = {}) {
  const query = all ? "?all=true" : "";
  const response = await fetchWithAuth(`${WHATSAPP_BASE}/accounts${query}`, { method: "GET" });
  return parseJson(response);
}

export async function disconnectWhatsAppAccount(accountId) {
  const response = await fetchWithAuth(`${WHATSAPP_BASE}/accounts/${accountId}`, {
    method: "DELETE",
  });
  return parseJson(response);
}

export async function getThreads({ businessId, status, page = 1, perPage = 30 }) {
  const query = new URLSearchParams();
  if (businessId) query.set("business_id", String(businessId));
  if (status) query.set("status", status);
  query.set("page", String(page));
  query.set("per_page", String(perPage));
  const response = await fetchWithAuth(`${BASE}/threads?${query.toString()}`, { method: "GET" });
  return parseJson(response);
}

export async function getThreadMessages(threadId, { page = 1, perPage = 50 } = {}) {
  const response = await fetchWithAuth(
    `${BASE}/threads/${threadId}/messages?page=${page}&per_page=${perPage}`,
    { method: "GET" }
  );
  return parseJson(response);
}

export async function sendCounsellorMessage(payload) {
  const response = await fetchWithAuth(`${BASE}/messages/send`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function assignThread(threadId, assignedCounsellorId) {
  const response = await fetchWithAuth(`${BASE}/threads/${threadId}/assign`, {
    method: "PATCH",
    body: JSON.stringify({ assigned_counsellor_id: assignedCounsellorId }),
  });
  return parseJson(response);
}

export async function updateThreadStatus(threadId, status, tag) {
  const response = await fetchWithAuth(`${BASE}/threads/${threadId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status, tag }),
  });
  return parseJson(response);
}
